import { MantineThemeOverride } from '@mantine/core';

export type UnstyledButtonTheme = NonNullable<MantineThemeOverride['components']>['UnstyledButton'];

export const UnstyledButton: UnstyledButtonTheme = {
  // todo: define
};
